import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import Tools from '../../tools';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
import '../../css/charge_item.scss';
// import { Link } from 'react-router-dom';
// import API from '../api';
// import { Cookies, withCookies } from 'react-cookie';
// import Enums from '../enums'

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default function ChargeItem(props) {
    const bgColorList = {
        "IT210805175157": [239, 239, 239],
        "IT210809111838": [206, 222, 220],
        "IT210809112018": [253, 210, 84],
        "IT210809112146": [251, 155, 149]
    }

    function render() {
        let { data } = props;
        if (null == data) data = {};
        let bgColor = {};
        // console.log(data.item_id, bgColorList, bgColorList.hasOwnProperty(data.item_id));
        if (data.item_id && bgColorList.hasOwnProperty(data.item_id)) {
            let color = bgColorList[data.item_id];
            bgColor = {
                background: `rgb(${color[0]}, ${color[1]}, ${color[2]})`
            };
        }

        // item_description: "(測試)進階套餐PLUS說明"
        // item_id: "IT210805175157"
        // item_name: "(測試)Premium PLUS"
        // item_type: "後台點數"
        // platform_point: 5000
        // price: 40000
        let promotedDom = (
            <div className="promote">
                <i class="bi bi-hand-thumbs-up"></i>最熱門
            </div>
        )
        let des_list = data.item_description ? data.item_description.split("\n") : [];
        let des_output = [];
        des_list.forEach(element => {
            des_output.push( <li>{element.replace("●","")}</li> );
        });
        console.log(des_output);

        return (
            <div className={"chargeItem " + (props.isPromoted ? "promoted" : "")}>
                {props.isPromoted ? promotedDom : null}
                <div className="title"><h4>{data.item_name ? data.item_name : ""}</h4></div>
                <div className="price"><h4><span>{(data.price ? Tools.formatPrice(data.price) : "")}</span><span>{"元"}</span></h4></div>
                <div className="btn"><Button variant="primary" onClick={() => { props.onClick(data.item_id) }}>開始使用</Button></div>
                <div className="desc"><ul>{des_output}</ul></div>
            </div>

            // <Card className="with-deco text-center m-2" style={bgColor}>
            //     <Card.Body>
            //         <Card.Title className="text-red"><h2>{(data.price ? data.price : "") + "元"}</h2></Card.Title>
            //         <Card.Text className="text-left">{data.item_description ? data.item_description : ""}</Card.Text>
            //         <Button variant="primary" onClick={() => { props.onClick(data.item_id) }}>購買</Button>
            //     </Card.Body>
            //     <small className="card-deco">
            //         {data.item_name ? data.item_name : ""}
            //     </small>
            // </Card>
        );
    }
    return render();
}